export default {"id":"icon-logo-text"}